import Image from 'app/Components/Shared/Image/image';
import React, {ReactNode, useRef, useState, useEffect} from 'react';
import useOnClickOutside from 'app/utilities/hooks/useOnClickOutside';
import classNames from 'classnames';

interface SelectProps<T> {
  placeholder: string;
  items: T[];
  selected: T | null;
  render: (item: T) => ReactNode | string;
  onSelect?: (item: T) => void;
}

function Select<T>({placeholder, items, render, selected, onSelect}: SelectProps<T>) {
  const ref = useRef();
  const [outside, setOutside] = useState(true);
  const toggle = (e) => setOutside(!outside);
  useOnClickOutside(ref, (outside) => outside && setOutside(true));
  const selectItem = (item: T) => {
    setOutside(true);
    onSelect(item);
  };

  const plural = items.length > 1;
  return (
    <div className={classNames('Select', {outside, selected})} ref={ref}>
      <div className='Select__input' onClick={toggle}>
        <div className='Select__value'>{selected ? render(selected) : placeholder}</div>
        {plural && <Image src={require('./images/icons-arrow-select.svg')} />}
      </div>
      {plural && (
        <div className='Select__options'>
          <div className='Select__options__container'>
            {items.map((item, i) => (
              <div className='Select__option' key={i} onClick={() => selectItem(item)}>
                {render(item)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Select;
